import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["email"]
  static values = { type: String }

  async submit(event) {
    event.preventDefault()

    const email = this.emailTarget.value.trim()
    if (!email) {
      this.showError('Please enter your email address.')
      return
    }

    // Disable form
    const submitBtn = this.element.querySelector('button[type="submit"]')
    const originalText = submitBtn.textContent
    submitBtn.disabled = true
    submitBtn.textContent = 'Joining...'

    try {
      const response = await fetch('/waitlist', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content
        },
        body: JSON.stringify({
          waitlist: {
            email: email,
            signup_type: this.typeValue
          }
        })
      })

      const data = await response.json()

      if (data.success) {
        this.showSuccess(data.message)
        this.emailTarget.value = ''
      } else {
        this.showError(data.message)
      }
    } catch (error) {
      this.showError('Something went wrong. Please try again.')
    } finally {
      submitBtn.disabled = false
      submitBtn.textContent = originalText
    }
  }

  showSuccess(message) {
    this.clearMessages()

    const successHTML = `
      <div class="mt-4 p-3 bg-green-100 dark:bg-green-900/30 border border-green-400 dark:border-green-600 text-green-700 dark:text-green-300 rounded text-sm">
        ${message}
      </div>
    `

    this.element.insertAdjacentHTML('afterend', successHTML)

    // Remove success message after 5 seconds
    setTimeout(() => {
      const successMsg = this.element.nextElementSibling
      if (successMsg && successMsg.classList.contains('bg-green-100')) {
        successMsg.remove()
      }
    }, 5000)
  }

  showError(message) {
    this.clearMessages()

    const errorHTML = `
      <div class="mt-4 p-3 bg-red-100 dark:bg-red-900/30 border border-red-400 dark:border-red-600 text-red-700 dark:text-red-300 rounded text-sm">
        ${message}
      </div>
    `

    this.element.insertAdjacentHTML('afterend', errorHTML)

    // Remove error message after 5 seconds
    setTimeout(() => {
      const errorMsg = this.element.nextElementSibling
      if (errorMsg && errorMsg.classList.contains('bg-red-100')) {
        errorMsg.remove()
      }
    }, 5000)
  }

  clearMessages() {
    // Remove any existing success/error messages
    const nextElement = this.element.nextElementSibling
    if (nextElement && (nextElement.classList.contains('bg-green-100') || nextElement.classList.contains('bg-red-100'))) {
      nextElement.remove()
    }
  }
} 
